import { render, staticRenderFns } from "./personnelBlacklist.vue?vue&type=template&id=2418d32a&scoped=true&"
import script from "./personnelBlacklist.vue?vue&type=script&lang=js&"
export * from "./personnelBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./personnelBlacklist.vue?vue&type=style&index=0&id=2418d32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418d32a",
  null
  
)

export default component.exports